/**
 * EmailOtpVerify — /auth/signin page.
 *
 * B2C owns the actual OTP UI (hosted page). This screen:
 *   - If already signed in → redirect to /dashboard.
 *   - If not signed in → button kicks off MSAL `loginRedirect`.
 *   - Post-redirect, B2C returns here; AuthContext's `initializeMsal` parses
 *     the hash; if `isAuthenticated` flips true, we navigate to /dashboard.
 *
 * Per rcp-module-v3.md gap "landing + OTP verify missing from mockups — synthesize".
 */

import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useAuth } from '../../contexts/AuthContext';
import { Mail } from 'lucide-react';

export function EmailOtpVerify(): JSX.Element {
  const { isAuthenticated, loading, login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && isAuthenticated) navigate('/dashboard', { replace: true });
  }, [loading, isAuthenticated, navigate]);

  return (
    <section className="card" style={{ maxWidth: 560, margin: '0 auto', padding: 32 }}>
      <h1 tabIndex={-1}>Sign in</h1>
      <p>
        We&apos;ll send a one-time code to your email. No passwords, no hassle.
      </p>
      <button
        type="button"
        className="btn btn-primary"
        onClick={() => void login('/dashboard')}
        disabled={loading}
        aria-busy={loading || undefined}
        style={{ width: '100%', justifyContent: 'center' }}
      >
        <Mail aria-hidden="true" size={18} />
        {loading ? 'Loading...' : 'Continue with email'}
      </button>
      <p style={{ marginTop: 24, fontSize: 13, color: 'var(--ink-500)' }}>
        Having trouble? Call us at{' '}
        <a href="tel:15733645202" aria-label="Call Phelps County Bank at 5 7 3, 3 6 4, 5 2 0 2">
          573-364-5202
        </a>{' '}
        during business hours.
      </p>
    </section>
  );
}
